import * as React from "react"
import type { SVGProps } from "react"
const SvgVerticalAlignBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21a1 1 0 0 1-.71-.29A1 1 0 0 1 4 20q0-.42.29-.71.29-.3.71-.29h14q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29zm7-4.43a1 1 0 0 1-.37-.06 1 1 0 0 1-.33-.21l-3.63-3.62A1 1 0 0 1 7.4 12q0-.4.3-.7a1 1 0 0 1 .7-.28q.42 0 .7.28l1.9 1.9V4q0-.42.29-.71.29-.3.71-.29.42 0 .71.29.3.29.29.71v9.2l1.93-1.92q.27-.28.67-.28t.7.3q.27.27.27.7t-.27.7l-3.6 3.6q-.14.15-.32.21a1 1 0 0 1-.38.06" />
  </svg>
)
export default SvgVerticalAlignBottom
